import { render, staticRenderFns } from "./editableTabs.vue?vue&type=template&id=9118561e&"
import script from "./editableTabs.vue?vue&type=script&lang=js&"
export * from "./editableTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports